import { Container } from 'components'
import { SectionContainerStyled } from 'components/atoms/container/index.styled'
import { ExpandedCard } from 'components/molecules/expandedCard'
import { IQAs } from 'interfaces/categories.interface'
// import CollapseIcon from 'public/svg/categories/collapse.svg'
// import ExpandIcon from 'public/svg/categories/expand.svg'
import QAIcon from 'public/svg/q&a.svg'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { deviceLayout } from 'styles/breakpoint'

const QAsStyled = styled(SectionContainerStyled)`
  ${deviceLayout.pcLayout`
    border-radius: 16px;
 `}

  ${deviceLayout.spLayout`
    border-radius: 16px;
    padding-bottom: 26px;
    margin-bottom: -16px;
 `}

  justify-content: center;
  padding: 16px;
  padding-bottom: 25px;
  background: ${(props) => props.theme.mbColors.lightBlue};
  border-radius: 16px 16px 0px 0px;
  header {
    justify-content: center !important;
    padding-top: 16px;
  }
  & > * {
    text-align: center;
  }

  .QA {
    padding: 12px;
    margin: 16px 0;
    background: #ffffff;
    border-radius: 16px;
    .content {
      text-align: left;
    }
    .title p {
      font-size: 14px;
      font-weight: 500;
      text-align: left;
    }
    .expandable-icon {
      right: 16px !important;
    }
  }
`

// const customIcon = {
//   min: <CollapseIcon />,
//   max: <ExpandIcon />,
// }

const QAs = ({ qas }: IQAs) => {
  const { formatMessage: f } = useIntl()
  return (
    <QAsStyled className="QAs">
      <Container>
        <QAIcon />
        <header>{f({ id: 'categoryPage.asked-question' })}</header>
        <SectionContainerStyled className="qa-container">
          {qas.map((qa, index: number) => (
            <ExpandedCard
              // customIcon={customIcon}
              key={`expanded-${index}`}
              iconPosition="right"
              {...qa}
              className="QA"
            />
          ))}
        </SectionContainerStyled>
      </Container>
    </QAsStyled>
  )
}

export default QAs
